module.exports = __webpack_public_path__ + "img/gift.19425fe2.png";